import React, { useState, useEffect } from "react";
import API_DOMAIN from "../config/config";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    padding: 26,
    position: "relative",
  },
  section: {
    flexDirection: "column",
    flexGrow: 1,
    border: 1,
    display: "flex",
  },
  text: {
    fontSize: 13,
    fontFamily: "Times-Roman",
    textAlign: "center",
    borderBottom: 1,
    width: "100%",
  },
  row: {
    flexDirection: "row",
  },
  label: {
    width: 65,
    fontSize: 9,
  },
  value: {
    flex: 1,
    fontSize: 9,
  },
  headertext: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    borderBottom: 1,
    width: "100%",
    padding: 2,
  },
  head: {
    fontSize: 10,
    display: "flex",
    flexDirection: "row",
    textAlign: "center",
  },
  invoice: {
    flex: 200,
    fontWeight: "bolder",
    fontSize: 13,
  },
  table: {
    display: "flex",
    borderBottom: 0.5,
    padding: 6,
    justifyContent: "flex-end",
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  tableCell: {
    flex: 4,
    fontSize: 9,
    fontFamily: "Times-Roman",
  },
  producthead: {
    fontSize: 9,
    fontFamily: "Times-Roman",
  },
  producttitle: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    display: "flex",
    flexDirection: "row",
    width: "100%",
    padding: 5,
    borderBottom: 1,
  },
  productbody: {
    fontSize: 8,
    fontFamily: "Times-Roman",
    display: "flex",
    flexDirection: "row",
    padding: 5,
  },
  bodydescription: {
    minHeight: 178,
  },
  no: {
    width: "10%",
    textAlign: "center",
    padding: 5,
  },
  particular: {
    width: "30%",
    textAlign: "left",
    padding: 5,
    flexWrap: "wrap",
  },
  qty: {
    width: "10%",
    textAlign: "center",
    padding: 5,
  },
  price: {
    width: "15%",
    textAlign: "center",
    padding: 5,
  },
  unit: {
    width: "15%",
    textAlign: "center",
    padding: 5,
  },
  amount: {
    width: "15%",
    textAlign: "center",
    padding: 5,
  },
  footer: {
    fontSize: 9,
    display: "flex",
    justifyContent: "flex-end",
    position: "absolute",
    bottom: 80,
    width: "100%",
    borderTop: 1,
  },
  footerRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  footerleft: {
    height: 62,
    borderBottom: 0.5,
  },
  footerCell: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    paddingVertical: 5,
    width: "100%",
  },
  right: {
    textAlign: "right",
  },
  totalBox: {
    position: "absolute",
  },
  w70: {
    width: "70%",
  },
  w30: {
    width: "30%",
  },
  priceRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
    borderBottom: 1,
    flexGrow: 15,
  },
  priceCell: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    paddingVertical: 5,
    flexGrow: 10,
    borderRight: 1,
    padding: 4,
    flexShrink: 1,
  },
  overall: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    paddingVertical: 5,
    padding: 5,
    flexGrow: 2.5,
    marginTop: 6,
  },
  paymentDetails: {
    marginTop: 10,
    marginBottom: 10,
  },
  paymentRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 2,
  },
  paymentMethod: {
    fontSize: 9,
    fontFamily: "Times-Roman",
  },
  paymentAmount: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    textAlign: "right",
  },
  signbox: {
    fontSize: 9,
    display: "flex",
    position: "absolute",
    bottom: 10,
    width: "100%",
  },
  signbill: {
    flexDirection: "row",
  },
  customsign: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    flexGrow: 200,
    marginTop: 15,
  },
  docs: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    padding: 5,
    marginTop: 15,
  },
  declration: {
    fontSize: 8,
    padding: 1,
  },
  boxdetails: {
    display: "flex",
    flexDirection: "row",
    borderBottom: 1,
  },
  boxdetailss: {
    display: "flex",
    flexDirection: "row",
  },
  box: {
    fontSize: 9,
    width: "50%",
    padding: 5,
  },
  brdright: { borderRight: 1 },
  brdrights: { borderRight: 1, borderBottom: 1 },
  brdtop: {
    borderTopWidth: 1,
    borderTopColor: "#000",
    borderTopStyle: "solid",
    width: "50%",
    paddingBottom: 1,
  },
  print: {
    fontSize: 9,
    textAlign: "right",
  },
  companyname: {
    fontWeight: "bold",
    fontSize: 9,
  },
  billed: {
    fontSize: 11,
    fontWeight: "bold",
  },
  boldText: {
    fontFamily: "Times-Roman",
    fontWeight: "bold",
    fontSize: 11,
  },
  ewayno: {
    marginBottom: 1,
    fontSize: 11,
    fontWeight: "bold",
  },
  stateof: {
    fontSize: 11,
    fontWeight: "bold",
  },
  remarks: {
    fontSize: 6,
  },
});

// Convert Rupees to Words function
const convertRupeesToWordsWithBreaks = (amount) => {
  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  const thousands = ["", "Thousand", "Lakh", "Crore"];

  function convertGroup(number, thousandIndex) {
    if (number === 0) return "";

    let str = "000" + number;
    str = str.slice(-3);

    const hundred = parseInt(str[0], 10);
    const ten = parseInt(str[1], 10);
    const one = parseInt(str[2], 10);

    let words = [];

    if (hundred > 0) {
      words.push(ones[hundred] + " Hundred");
    }

    if (ten === 1) {
      words.push(teens[one]);
    } else {
      if (ten > 0) {
        words.push(tens[ten]);
      }
      if (one > 0) {
        words.push(ones[one]);
      }
    }

    if (thousandIndex > 0 && words.length > 0) {
      words.push(thousands[thousandIndex]);
    }

    return words.join(" ");
  }

  function convertIntegerPart(integerPart) {
    const groups = [];
    let thousandIndex = 0;

    while (integerPart > 0) {
      groups.push(
        convertGroup(
          integerPart % (thousandIndex === 1 ? 100 : 1000),
          thousandIndex
        )
      );
      integerPart = Math.floor(
        integerPart / (thousandIndex === 1 ? 100 : 1000)
      );
      thousandIndex++;
    }

    const resultGroups = groups.reverse().filter((group) => group !== "");
    const lastGroupIndex = resultGroups.length - 1;
    const formattedGroups = resultGroups.map((group, index) =>
      index === lastGroupIndex ? group : group
    );

    return formattedGroups.join(" ");
  }

  function convertDecimalPart(decimalPart) {
    if (decimalPart === 0) {
      return "";
    }

    let paise = Math.round(decimalPart * 100);
    return convertGroup(paise, 0) + " Paise";
  }

  const integerPart = Math.floor(amount);
  const decimalPart = amount - integerPart;

  const integerWords = convertIntegerPart(integerPart);
  const decimalWords = convertDecimalPart(decimalPart);

  const result =
    integerWords + " Rupees" + (decimalWords ? "\nAnd " + decimalWords : "");
  return result.trim();
};

const SalesEstimatePDF = ({ data, type }) => {
  const [userdata, setUserData] = useState([]);

  const filteredUserData = userdata.filter(
    (item) => item.company_id === data.party_details.company_id
  );

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/company.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      if (responseData.status === 200) {
        setUserData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const totalGST = Number(data.overall_tax_amount || 0).toFixed(2);
  const isIGST = (data.overall_tax_percentage || "")
    .toLowerCase()
    .includes("igst");
  const sgstAmount = isIGST ? "0.00" : (Number(totalGST) / 2).toFixed(2);
  const cgstAmount = isIGST ? "0.00" : (Number(totalGST) / 2).toFixed(2);

  const words = convertRupeesToWordsWithBreaks(data.total);

  // Split products into chunks of 15
  const productsPerPage = 15;
  const productChunks = [];
  for (let i = 0; i < data.product.length; i += productsPerPage) {
    productChunks.push(data.product.slice(i, i + productsPerPage));
  }

  return (
    <Document>
      {productChunks.map((chunk, pageIndex) => (
        <Page size="A4" style={styles.page} key={pageIndex}>
          <View style={styles.section}>
            {/* Header */}
            <View style={styles.headertext}>
              <Text style={styles.print}>[{type}]</Text>
              <View style={styles.head}>
                <Text style={styles.invoice}>Tax Estimation</Text>
              </View>
            </View>

            {/* Address Section */}
            <View style={styles.boxdetailss}>
              <View style={[styles.box, styles.brdrights]}>
                <Text style={[styles.billed, styles.boldText]}>
                  Billed By : {data.company_details.company_name}
                </Text>
                <Text>{data.company_details.address}</Text>
                <Text>{data.company_details.city}</Text>
                <Text>{data.company_details.state}</Text>
                <Text>GST : {data.company_details.gst_no}</Text>
                <Text>Ph : {data.company_details.mobile_number}</Text>
              </View>
              <View style={styles.box}>
                <Text style={styles.ewayno}>Estimation No: {data.bill_no}</Text>
                <Text style={styles.ewayno}>Date: {data.bill_date}</Text>
                <Text style={styles.ewayno}>
                  State Of Supply: {data.state_of_supply}
                </Text>
                <Text style={styles.ewayno}>E-way Bill No: {data.eway_no}</Text>
                <Text style={styles.ewayno}>Vehicle No: {data.vechile_no}</Text>
              </View>
            </View>
            <View style={styles.boxdetails}>
              <View style={[styles.box, styles.brdright]}>
                <Text style={[styles.billed, styles.boldText]}>
                  Ship To : {data.party_name}
                </Text>
                <Text>Address : {data.address}</Text>
                <Text>Ph : {data.mobile_number}</Text>
                <Text>GST : {data.gst_no}</Text>
              </View>
            </View>

            {/* Product Table */}
            <View style={styles.producthead}>
              <View style={styles.producttitle}>
                <Text style={styles.no}>S No</Text>
                <Text style={styles.particular}>Particular</Text>
                <Text style={styles.qty}>Qty</Text>
                <Text style={styles.unit}>Unit</Text>
                <Text style={styles.price}>Price</Text>
                <Text style={styles.amount}>Amount</Text>
              </View>
              <View style={styles.bodydescription}>
                {chunk.map((product, index) => (
                  <View style={styles.productbody} key={index}>
                    <Text style={styles.no}>
                      {pageIndex * productsPerPage + index + 1}
                    </Text>
                    <Text style={styles.particular}>
                      {product.product_name}
                    </Text>
                    <Text style={styles.qty}>{product.qty}</Text>
                    <Text style={styles.unit}>{product.unit_name}</Text>
                    <Text style={styles.price}>{product.price_unit}</Text>
                    <Text style={styles.amount}>{product.total_amt}</Text>
                  </View>
                ))}
              </View>
            </View>

            {/* Footer - Bank and Amount Details (only on the last page) */}
            {pageIndex === productChunks.length - 1 && (
              <>
                <View style={styles.footer}>
                  <View style={styles.boxdetails}>
                    <View style={[styles.box, styles.brdright, styles.w70]}>
                      <Text>Bank Name : {data.company_details.bank_name}</Text>
                      <Text>Account No: {data.company_details.acc_no}</Text>
                      <Text>IFSC : {data.company_details.ifsc_code}</Text>
                    </View>
                    <View style={[styles.box, styles.w30]}>
                      <View style={styles.row}>
                        <Text style={styles.label}>Sub Total</Text>
                        <Text style={styles.value}>
                          : {parseFloat(data.sub_total).toFixed(2)}
                        </Text>
                      </View>
                      <View style={styles.row}>
                        <Text style={styles.label}>
                          Discount {data.discount} %
                        </Text>
                        <Text style={styles.value}>
                          :{" "}
                          {parseFloat(data.overall_discount_amount).toFixed(2)}
                        </Text>
                      </View>
                      {isIGST ? (
                        <View style={styles.row}>
                          <Text style={styles.label}>IGST</Text>
                          <Text style={styles.value}>
                            : {parseFloat(totalGST).toFixed(2)}
                          </Text>
                        </View>
                      ) : (
                        <>
                          <View style={styles.row}>
                            <Text style={styles.label}>SGST</Text>
                            <Text style={styles.value}>
                              : {parseFloat(sgstAmount).toFixed(2)}
                            </Text>
                          </View>
                          <View style={styles.row}>
                            <Text style={styles.label}>CGST</Text>
                            <Text style={styles.value}>
                              : {parseFloat(cgstAmount).toFixed(2)}
                            </Text>
                          </View>
                        </>
                      )}
                    </View>
                  </View>
                  <View style={styles.priceRow}>
                    <Text style={[styles.priceCell, styles.w70]}>
                      Amount in words : {words} Only
                    </Text>
                    <Text style={[styles.overall, styles.w30]}>
                      NET AMOUNT : {Number(data.total || 0).toFixed(2)}
                    </Text>
                  </View>
                </View>

                {/* Signature Section (only on the last page) */}
                <View style={styles.signbox}>
                  <View style={styles.signbill}>
                    <View style={styles.customsign}>
                      <Text>Customer Sign</Text>
                    </View>
                    <Text style={styles.docs}>
                      For {data.company_details.company_name}
                    </Text>
                  </View>
                  <View>
                    <Text style={styles.declration}>
                      We Declare that this Estimation shows the actual price of
                      the goods described and that all particulars are true and
                      correct
                    </Text>
                  </View>
                </View>
              </>
            )}
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default SalesEstimatePDF;
